import { render, staticRenderFns } from "./OxygenAccordionInput.vue?vue&type=template&id=95667622&"
import script from "./OxygenAccordionInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenAccordionInput.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenAccordionInput.vue?vue&type=style&index=0&id=95667622&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports